export enum EntityType {
    Organization = 1,
    Site = 2,
    CropCycle = 3,
    Zone = 4
}